// Commands are disabled in the mobile native version.
export default function useCommands() {}
